import { useMemo } from 'react'

// We need this default duration to be able to display
// old appointments with duration 0 that do not have
// appointment templates for its type defined. This happens
// mostly for old data migrated (past appointments).
let DEFAULT_APPOINTMENT_DURATION = 10

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  return useMemo(() => {
    // Events for calendar: this query and data context retrieves
    // the main events we need for the timegrid, appointment bookings
    // and shedule notes (that has blocked times and calendar notes)
    // This is the query that reacts to event updates when necessary
    return {
      appointment_bookings:
        data?.vaxiom_appointment_bookings?.map(item => ({
          ...item,
          duration:
            item.duration > 0
              ? item.duration
              : item.appointment.type.appointment_templates?.length
              ? Math.max(
                  ...item.appointment.type.appointment_templates.map(
                    at => at.duration
                  )
                )
              : DEFAULT_APPOINTMENT_DURATION,
        })) || [],
      schedule_notes:
        data?.vaxiom_schedule_notes.map(note => ({
          ...note,
          //in the future, this will be a full history table, but for now
          //we simulate it by mapping it like this.
          history: [
            {
              timestamp: note.sys_created,
              user: note.created_by,
            },
            note.sys_last_modified !== note.sys_created
              ? {
                  timestamp: note.sys_last_modified,
                  user: note.modified_by,
                }
              : undefined,
          ].filter(Boolean),
        })) || [],
    }
  }, [data])
}
